module.exports = __webpack_public_path__ + "static/media/square1.e4f9c8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/square1.png
// module id = 1858
// module chunks = 0 1